'use client'

import { type HTMLAttributes, useState } from 'react'
import {
  PageHeader,
  PageHeaderDescription,
  PageHeaderHeading,
} from '@/components/landing/page-header'
import { config } from '@/config'
import { Entitlement } from '@/lib/polar/types'
import { cn } from '@/utils/cn'
import { LaunchCouponCode } from './coupon-code'
import { getPersonalizedPricingText } from './personalization'
import { PricingPlanItem } from './pricing-plan-item'

interface SubscriptionsPricingPlansProps extends HTMLAttributes<HTMLDivElement> {
  mode: 'landing' | 'app'
  onboardingProblemId?: string | null
  onboardingRoleId?: string | null
  onboardingOrganizationId?: string | null
}

export function SubscriptionsPricingPlans({
  className,
  mode,
  onboardingProblemId,
  onboardingRoleId,
  onboardingOrganizationId,
  ...props
}: SubscriptionsPricingPlansProps) {
  const [recurringInterval, setRecurringInterval] = useState<'month' | 'year'>('month')

  const handleTabChange = (tab: 'month' | 'year') => {
    setRecurringInterval(tab)
  }

  const currentPersonalizedText = getPersonalizedPricingText(
    onboardingProblemId,
    onboardingRoleId,
    onboardingOrganizationId,
  )

  return (
    <div className={cn('mx-auto w-full max-w-6xl py-12', className)} {...props}>
      <PageHeader className="!pb-10 sm:pt-0 md:pt-0 lg:pt-0 2xl:pt-0" id="pricing">
        <PageHeaderHeading level="h2">{currentPersonalizedText.header}</PageHeaderHeading>
        <PageHeaderDescription className="text-base sm:text-lg">
          {currentPersonalizedText.description}
        </PageHeaderDescription>
      </PageHeader>

      <LaunchCouponCode />

      <div className="pt-5 pb-10">
        {/* <SubscriptionPlansTabs
          activeTab={recurringInterval}
          setActiveTab={handleTabChange}
          className="mx-auto w-full max-w-md"
        >
          {(activeTab) => (
            <SubscriptionPlansTabsList>
              {['year', 'month'].map((tab) => (
                <SubscriptionPlansTabsTrigger
                  key={tab}
                  value={tab}
                  onClick={() => handleTabChange(tab as 'year' | 'month')}
                  isActive={activeTab === tab}
                >
                  {tab === 'year' ? 'Yearly' : 'Monthly'}
                  {tab === 'year' && (
                    <span className="ml-2 font-semibold text-green-500 text-xs">Save 20%</span>
                  )}
                </SubscriptionPlansTabsTrigger>
              ))}
            </SubscriptionPlansTabsList>
          )}
        </SubscriptionPlansTabs> */}
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:gap-6">
        <PricingPlanItem
          plan={config.pricingPlans[Entitlement.PRO]}
          interval={recurringInterval}
          mode={mode}
        />
        <PricingPlanItem
          plan={config.pricingPlans[Entitlement.ULTRA]}
          interval={recurringInterval}
          mode={mode}
        />
        <PricingPlanItem
          plan={config.pricingPlans[Entitlement.ENTERPRISE]}
          interval={recurringInterval}
          mode={mode}
          className="md:col-span-2 lg:col-span-1"
        />
      </div>
    </div>
  )
}
